import { format } from "date-fns";
import {
  Button,
  CardHeader,
  DataGrid,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "../../../../components";
import { formatPrice } from "../../../../utils";

function HistoricoMovimentacao({
  open,
  setOpen,
  historicoMovimentacaoList,
  rowCount,
  produtosGradeList,
  filtroTipo,
  setFiltroTipo,
  sendServerDatagrid,
}) {

  const colunaGrade = produtosGradeList.length > 0 
    ? 
    [{
      field: "estProdutoId",
      headerName: "Produto",
      flex: 2000,
      valueGetter: (params) => {
        const produtoGrade = produtosGradeList.find(({id}) => id === params.row.estProdutoId);
        return produtoGrade.descricao;
      },
    }]
    : [];
  const colunas = [
    {
      field: "numeroDocumento",
      headerName: "Número Documento",
      flex: 1000,
    },
    {
      field: "serieDocumento",
      headerName: "Série Documento",
      flex: 1000,
    },
    ...colunaGrade,
    {
      field: "quantidade",
      headerName: "Quantidade",
      flex: 1000,
      align: 'center',
      headerAlign: 'center', 
    },
    {
      field: "createdAt",
      headerName: "Data",
      flex: 1000,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (params) =>
        format(new Date(params.value), "dd/MM/yyyy HH:mm"),
    },
    {
      field: "precoUnitario",
      headerName: "Subtotal",
      flex: 1000,
      align: 'right',
      headerAlign: 'right',
      valueGetter: (params) =>
        formatPrice(params.value * params.row.quantidade, false),
    },
  ];

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeFiltroTipo = (event) => {
    setFiltroTipo(event.target.value);
  }

  return (
    <Dialog maxWidth={produtosGradeList.length > 0 ? "xl" : "lg"} fullWidth open={open}>
      <DialogContent>
        <CardHeader
          title="Histórico de Movimentações"
          action={
            <Button onClick={handleClose} variant="contained" color="padrao">
              fechar
            </Button>
          }
          sx={{
            padding: "0px !important",
            my: "12px !important"
          }}
        />
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={filtroTipo || "saida"}
            onChange={handleChangeFiltroTipo}
          >
            <FormControlLabel
              value="entrada"
              control={<Radio />}
              label="Entrada"
            />
            <FormControlLabel
              value="saida"
              control={<Radio />}
              label="Saída"
            />
          </RadioGroup>
        </FormControl>
        <Grid container spacing={4}>
          <Grid className="mt-2" item xs={12}>
            <DataGrid
              rows={historicoMovimentacaoList}
              columns={colunas}
              rowCount={rowCount}
              disableAcoes
              noFilter
              paginationMode={"server"}
              sendServer={sendServerDatagrid}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  );
}

export default HistoricoMovimentacao;
